<template>
  <div class="tf-container">
    <div class="tf">
      <label
        v-if="title"
        class="tf-label"
      >
        {{ title }} <span v-show="!required">(Optional)</span> <slot name="tooltip" />
      </label>
      <slot v-else name="label" />
      <input
        v-if="!isTextArea"
        :class="['tfi', hasError && 'error']"
        :disabled="disabled"
        :value="value"
        :maxlength="maxLength"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur')"
        @change="$emit('change', $event.target.value)"
        :id="`${title}-input-id`"
      >
      <textarea
        v-else
        :class="['tft', hasError && 'error']"
        :disabled="disabled"
        :value="value"
        :maxlength="maxLength"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur')"
        @change="$emit('change', $event.target.value)"
        :id="`${title}-input-id`"
      />
      <p
        v-show="description"
        class="tf-desc"
      >
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
import VueTheMask from 'vue-the-mask';

export default {
  name: 'TextField',
  props: {
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    hasError: {
      type: Boolean,
      required: false,
    },
    value: {
      type: String,
    },
    maxLength: {
      type: Number,
      required: false,
      default: undefined,
    },
    isTextArea: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  directives: {
    mask: VueTheMask.directive,
  },
};
</script>
